import { supabase } from '@/lib/supabaseClient';

export type PartnerWidgetLocale = 'fr' | 'en';

export type PartnerWidgetCatalogItem = {
  businessId: string;
  itemId: string;
  name: string;
  description?: string | null;
  timezone: string;
};

export type PartnerWidgetAvailability = {
  startAt: string;
  endAt: string;
  remainingCapacity: number;
};

const FUNCTION_NAME = 'reserve-partner-api';

function assertPublicKey(value: string): string {
  const normalized = value.trim();
  if (!/^[a-zA-Z0-9_-]{16,96}$/.test(normalized)) {
    throw new Error('Invalid partner widget key');
  }
  return normalized;
}

export async function partnerWidgetRequest<T>(
  publicKey: string,
  action: 'catalog' | 'availability' | 'create_hold' | 'booking_status',
  payload: Record<string, unknown>,
): Promise<T> {
  const { data, error } = await supabase.functions.invoke(FUNCTION_NAME, {
    body: {
      action,
      publicKey: assertPublicKey(publicKey),
      ...payload,
    },
  });

  if (error) throw error;
  if (!data || data.ok !== true) {
    throw new Error(data?.error ?? 'Partner API request failed');
  }
  return data.result as T;
}
